import { inject, Injectable } from '@angular/core';
import { ServiceInfoCollectionData } from '../../../../../../models/order/workflow/service-info-collection.model';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { OrderApiResponseStateService } from '../../order-api-response/order-api-response-state.service';



@Injectable({ providedIn: 'root' })
export class ServiceInformationCollectionStateService extends BaseWorkflowStateService<ServiceInfoCollectionData> {
    private orderApiResponseState: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    protected override stateKey: string = 'serviceInfoCollection';
    serviceAvailabilityData = this.orderApiResponseState.serviceAvailabilityData;
    customerData = this.orderApiResponseState.customer;
}